import { useCallback, useEffect, useRef, useState } from "react";
import { api } from "@/lib/api";

/** GET con polling opcional (sincronización en tiempo real). */
export function useFetch(path, { poll = 0, deps = [] } = {}) {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const [lastSync, setLastSync] = useState(null);
  const alive = useRef(true);

  const load = useCallback(async () => {
    if (!path) return;
    try {
      const { data } = await api.get(path);
      if (!alive.current) return;
      setData(data);
      setError(null);
      setLastSync(new Date());
    } catch (e) {
      if (alive.current) setError(e);
    } finally {
      if (alive.current) setLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [path, ...deps]);

  useEffect(() => {
    alive.current = true;
    load();
    let t;
    if (poll) t = setInterval(load, poll);
    return () => { alive.current = false; if (t) clearInterval(t); };
  }, [load, poll]);

  return { data, error, loading, reload: load, lastSync, setData };
}
